<script setup lang="ts">
import { ref, onMounted, onUnmounted, reactive } from "vue";

// 产品配置数据
const products = [
  // {
  //   id: "1820653414049120258",
  //   image: "/华域视觉大灯.png",
  //   titleKey: "system.home.tu_yc.o_a",
  //   descKey: "system.home.tu_yc.o_b",
  // },
  {
    id: "1902894864857649154",
    image: "/华域视觉大灯.png",
    titleKey: "system.home.tu_sj.o_a",
    descKey: "system.home.tu_sj.o_b",
  },
  {
    id: "1902887676885946369",
    image: "/449a5d17c9ed699e448d10680a6865a.png",
    titleKey: "system.home.tu_t.o_a",
    descKey: "system.home.tu_t.o_b",
  },
  {
    id: "1902887676885946369",
    image: "/日用友捷电子扇.jpg",
    titleKey: "system.home.tu_th.o_a",
    descKey: "system.home.tu_th.o_b",
  },
  {
    id: "1902887122176659457",
    image: "/东安动力发动机.jpg",
    titleKey: "system.home.tu_qr.o_a",
    descKey: "system.home.tu_qr.o_b",
  },

  // {
  //   id: "1820653414049120258",
  //   image: "/东安动力发动机.jpg",
  //   titleKey: "system.home.tu_o.o_a",
  //   descKey: "system.home.tu_o.o_b",
  // },

  // {
  //   id: "1820653810733809666",
  //   image: "/dalu.png",
  //   titleKey: "system.home.tu_f.o_a",
  //   descKey: "system.home.tu_f.o_b",
  // },
  // {
  //   id: "1820653925955534850",
  //   image: "/未标题-1.jpg",
  //   titleKey: "system.home.tu_fi.o_a",
  //   descKey: "system.home.tu_fi.o_b",
  // },
];

const leftTransform = reactive(
  Array(products.length)
    .fill(0)
    .reduce((acc, _, index) => {
      acc[index] = "translateX(0)";
      return acc;
    }, {})
);

const rightTransform = reactive(
  Array(products.length)
    .fill(0)
    .reduce((acc, _, index) => {
      acc[index] = "translateX(0)";
      return acc;
    }, {})
);

const handleScroll = () => {
  requestAnimationFrame(() => {
    products.forEach((_, index) => {
      const containerElement = document.querySelector(
        `.product-section-${index}`
      );
      if (containerElement) {
        const containerBounds = containerElement.getBoundingClientRect();
        const threshold = window.innerHeight * 0.5;

        if (containerBounds.top <= threshold && containerBounds.bottom >= 0) {
          leftTransform[index] = "translate3d(0, 0, 0)";
          rightTransform[index] = "translate3d(0, 0, 0)";
          containerElement.classList.add("visible");
        } else {
          leftTransform[index] = "translate3d(-100px, 0, 0)";
          rightTransform[index] = "translate3d(100px, 0, 0)";
          containerElement.classList.remove("visible");
        }
      }
    });
  });
};

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>

<template>
  <div class="dongtu">
    <div class="product-list">
      <template v-for="(product, index) in products" :key="product.id">
        <div
          :class="[
            'product-section',
            `product-section-${index}`,
            { 'product-section--gray': index % 2 === 1 },
          ]"
        >
          <RouterLink
            :to="`/home/productlist?cid=${product.id}`"
            class="product-inner"
          >
            <div
              class="product-content"
              :class="{ 'product-content--reverse': index % 2 === 1 }"
            >
              <div
                class="product-image"
                :style="{ transform: leftTransform[index] }"
              >
                <img :src="product.image" :alt="$t(product.titleKey)" />
              </div>
              <div
                class="product-info"
                :style="{ transform: rightTransform[index] }"
              >
                <div class="info-box">
                  <h2 class="info-title">{{ $t(product.titleKey) }}</h2>
                  <p class="info-desc">{{ $t(product.descKey) }}</p>
                  <div class="info-link">
                    <van-icon class="link-icon" name="arrow" />
                  </div>
                </div>
              </div>
            </div>
          </RouterLink>
        </div>
      </template>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.dongtu {
  width: 100%;
  background-color: #fff;
}

.product-list {
  width: 100%;
}

.product-section {
  width: 100%;
  height: 600px;
  position: relative;
  background-color: #fff;

  &--gray {
    background-color: #f5f5f5;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #f5f5f5;
    }

    .product-image {
      background-color: #f5f5f5;

      img {
        background-color: #f5f5f5;
        mix-blend-mode: multiply;
      }
    }
  }
}
.product-inner {
  position: relative;
  max-width: 1200px;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 0 15px;
  display: flex;
  align-items: center;
  background-color: inherit;
}

.product-image {
  position: relative;
  flex: 0 0 550px;
  width: 550px;
  height: 600px;
  overflow: hidden;
  transform: translate3d(-100px, 0, 0);
  transition: all 1s cubic-bezier(0.4, 0, 0.2, 1);
  background-color: inherit;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.product-content {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;

  &--reverse {
    flex-direction: row-reverse;
  }
}

.product-info {
  position: relative; // 添加相对定位
  flex: 0 0 520px;
  width: 520px;
  padding: 0 50px;
  transform: translate3d(100px, 0, 0);
  transition: all 1s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: transform, opacity;
}

.info-box {
  width: 100%;
  max-width: 450px;

  .info-title {
    font-size: 50px;
    color: #004080;
    line-height: 1.1;
    margin-bottom: 30px;
  }

  .info-desc {
    font-size: 20px;
    line-height: 26px;
    color: #3e3a39;
    margin-bottom: 40px;
  }

  .info-link {
    width: 65px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    border: 2px #004080 solid;
    border-radius: 5px;
    transition: all 0.3s ease;

    .link-icon {
      color: #004080;
      font-size: 20px;
    }

    &:hover {
      background-color: #004080;
      .link-icon {
        color: #fff;
      }
    }
  }
}
</style>